module.exports = __webpack_public_path__ + "img/avatar-s-10.7be10c57.png";